"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var t = require('styled-components');
var reactProgress = require('@radix-ui/react-progress');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var t__default = /*#__PURE__*/_interopDefaultLegacy(t);

var o=t__default["default"](reactProgress.Indicator)`
  background: var(--progress-default);
  height: 100%;
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  transition: 0.25s ease;
  background: ${({$variant:r})=>{switch(r){case"success":return "var(--color-green-600)";case"error":return "var(--color-pink-600)";default:return "var(--color-blurple-600)"}}};
`,a=t__default["default"](reactProgress.Root)`
  height: 8px;
  min-width: 100px;
  border-radius: 100px;
  overflow: hidden;
  background: var(--color-neutral-100);

  &[data-value='100'] {
    ${o} {
      border-top-right-radius: 100px;
      border-bottom-right-radius: 100px;
    }
  }
`;var i=({variant:r="default",max:p=100,value:e=0,...d})=>jsxRuntime.jsx(a,{max:p,value:e,"aria-label":"Progress bar",...d,children:jsxRuntime.jsx(o,{$variant:r,style:{width:`${e}%`}})});i.displayName="Progress";var m=t__default["default"](i)``;

exports.a = m;
